<template>
    <div class="modal-overlay " >
        <div class="modal position-relative">
               <span  class="delete-icon"
                      @click="$emit('close-modal', true)">
                                <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                            </span>
            <p class="cssMessage">{{message}}</p>
            <div class="d-flex gap-3" v-if="training_type !== null">
                <button class="cancle-btn" @click="confirmHandler('entities' , 'Team')">Teams</button>
                <button class="cancle-btn" @click="confirmHandler('users' , 'Users')">Users</button>
            </div>
            <div v-else class="d-flex gap-3">
                <button v-if="participant === 'individual'" class="cancle-btn" @click="confirmHandler('users' , 'Users')">Users</button>
                <button v-else class="cancle-btn" @click="confirmHandler('entities' , 'Team')">Teams</button>
            </div>

        </div>
    </div>
</template>

<script>
    import competition from "../../api-services/competition";

    export default {
        name:'assign-component',
        props: ['confirmUsers', 'confirmTeam', 'confirmTeamLeader' , 'message' , 'participant' , 'training_type' , 'whoPlay'],
        data(){
            return {
                state: false,
                data: null,
                competition:{},
                participant_type:null
            }
        },
        async mounted(){
            // const competition_id = this.$route.params.id;
            // this.competition = await competition.show(competition_id);
            // console.log(this.participant);
            // console.log(this.training_type);
            // console.log(this.whoPlay);
        },
        methods:{
            async confirmHandler(type , message){
                const competition_id = this.$route.params.id;
                if(this.training_type !== null){
                    this.data = await competition.getNotUsersAssignedTraining(type , competition_id);
                    // console.log(this.data);
                    this.$emit('clickAssign' , [message , this.data]);
                }else{
                    this.data = await competition.getNotUsersAssigned(type , competition_id);
                    this.$emit('clickAssign' , [message , this.data]);
                }
            }
        }

    }
</script>

<style scoped>
    .cssMessage{
        color: var(--text-color-in-confirmation-modal);
    }

    .delete-icon {
        position: absolute;
        top:40.5%;
        right: 31%;
        display: flex;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #0e2731;
        background-color: #e95626;
        cursor: pointer;
    }

    .modal-overlay {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #021a24cc;
        z-index: 9999;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: unset !important;
        background-color: var(--background-color-input-create);
        height: 200px;
        border-radius: 20px;
        margin: auto;
        width: 40%;
    }


    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .delete-icon{
            top: 36.5%;
        }
    }


    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 22px;
        margin: 30px 0;
        color: #FFF;
    }

    button {
        width: 150px;
        height: 50px;
        color: white;
        font-size: 18px;
        border-radius: 8px;
        font-weight: 600;
    }

    .cancle-btn{
        background-color: transparent;
        color: var(--text-color-in-confirmation-modal);
        border: 1px solid var(--text-border-color-in-confirmation-modal);
    }
</style>